/** 管理者：聊手權限（可接管哪些平台）。 */
import { useEffect, useState } from 'react';
import { createGrant, deleteGrant, listGrants } from '../../lib/fleetApi';

export function GrantsPage() {
  const [rows, setRows] = useState<
    Array<{
      id: string;
      operatorEmail: string;
      platform: string;
      persona: string;
      canTakeover: number;
      canSend: number;
    }>
  >([]);
  const [email, setEmail] = useState('');
  const [platform, setPlatform] = useState('*');
  const [error, setError] = useState<string | null>(null);

  async function reload() {
    try {
      const { grants } = await listGrants();
      setRows(grants);
      setError(null);
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    }
  }

  useEffect(() => {
    void reload();
  }, []);

  async function remove(id: string) {
    setError(null);
    try {
      await deleteGrant(id);
      await reload();
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    }
  }

  async function add() {
    if (!email.trim()) return;
    try {
      await createGrant({ operatorEmail: email.trim(), platform: platform.trim() || '*' });
      setEmail('');
      await reload();
    } catch (err) {
      setError(err instanceof Error ? err.message : String(err));
    }
  }

  return (
    <div className="flex flex-col gap-3 p-3" data-testid="grants-page">
      <header>
        <p className="text-[11px] uppercase tracking-widest text-text-tertiary">管理者</p>
        <h1 className="font-serif text-xl">聊手權限</h1>
      </header>
      {error ? (
        <div className="flex flex-wrap items-center gap-2 text-sm text-danger" role="alert">
          <span>{error}</span>
          <button
            type="button"
            className="rounded border border-border px-2 py-0.5 text-xs text-text"
            onClick={() => void reload()}
          >
            重試
          </button>
        </div>
      ) : null}
      <div className="flex flex-wrap gap-2">
        <input
          className="rounded border border-border bg-transparent px-2 py-1.5 text-sm"
          placeholder="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
        <input
          className="w-28 rounded border border-border bg-transparent px-2 py-1.5 text-sm"
          placeholder="platform"
          value={platform}
          onChange={(e) => setPlatform(e.target.value)}
        />
        <button
          type="button"
          className="rounded border border-border px-3 py-1.5 text-sm"
          onClick={() => void add()}
        >
          新增
        </button>
      </div>
      {error && rows.length === 0 ? (
        <p className="text-xs text-text-tertiary">讀不到授權清單（不是「還沒有授權」）。</p>
      ) : (
        <table className="w-full text-left text-sm">
          <thead>
            <tr className="text-text-tertiary">
              <th className="py-1">email</th>
              <th>platform</th>
              <th>persona</th>
              <th />
            </tr>
          </thead>
          <tbody>
            {rows.map((g) => (
              <tr key={g.id} className="border-t border-border">
                <td className="py-1 font-mono text-xs">{g.operatorEmail}</td>
                <td>{g.platform}</td>
                <td>{g.persona}</td>
                <td>
                  <button
                    type="button"
                    className="text-xs text-danger"
                    onClick={() => void remove(g.id)}
                  >
                    刪除
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      )}
    </div>
  );
}
